import { graphql } from 'react-relay';

export const gqlTopRanking = graphql`
  query topRankingQuery(
    $institution: Int
    $competition: InvsysAnalyticsCompetitionType!
    $frequency: InvsysAnalyticsCompetitionFrequencyType!
  ) {
    invsysTopRanking(institution: $institution, competition: $competition, frequency: $frequency) {
      score
      rank
      imageUrl
    }
  }
`;
